import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  // FastAPI structured error payloads (e.g. Launch Guard) surface as a dict
  // like {"error": "CODE", "message": "human-readable reason", ...}.  Prefer
  // the human message, then the code, then a JSON fallback so operators
  // always see *something* actionable in the toast.
  if (detail && typeof detail === "object") {
    if (typeof detail.message === "string" && detail.message.trim()) return detail.message;
    if (typeof detail.error === "string" && detail.error.trim()) return detail.error;
    if (typeof detail.reason === "string" && detail.reason.trim()) return detail.reason;
    try { return JSON.stringify(detail); } catch { /* fall through */ }
  }
  return String(detail);
}

export default api;
